import { FOOTER_LINKS } from '@/mocks/data';

function scrollToId(id: string) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}

const SECTION_BY_GROUP: Record<string, string[]> = {
  栏目导航: ['feed', 'channels', 'rank', 'reports', 'faq'],
  分类频道: [],
  关于站点: ['about', 'about', 'subscribe', 'subscribe'],
};

export default function Footer() {
  const year = new Date().getFullYear();

  const handleClick = (group: string, name: string) => {
    if (group === '分类频道') {
      window.dispatchEvent(new CustomEvent('heigua-feed', { detail: name }));
      scrollToId('feed');
      return;
    }
    const list = SECTION_BY_GROUP[group] || [];
    const idx = FOOTER_LINKS.find((g) => g.group === group)?.items.indexOf(name) ?? 0;
    const target = list[idx] || 'about';
    scrollToId(target);
  };

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 font-heading text-xl font-black text-background-50">
                瓜
              </span>
              <span className="leading-tight">
                <span className="block font-heading text-xl font-black text-background-50">51黑瓜速递</span>
                <span className="block text-xs text-background-300">全网热点汇总抢先看</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-300">
              一个专注聚合全网热点的资讯频道,实时汇总娱乐、科技、社会、网络文化等分类的热议话题与热搜榜单,每日更新,帮你第一时间掌握瓜田风向,吃瓜不迷路。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-2">
              <span className="flex items-center gap-1.5 rounded-full bg-background-800 px-3 py-1.5 text-xs text-background-200">
                <i className="ri-mail-line text-primary-400"></i>
                hello@51heigua.cn
              </span>
              <span className="flex items-center gap-1.5 rounded-full bg-background-800 px-3 py-1.5 text-xs text-background-200">
                <i className="ri-time-line text-primary-400"></i>
                全天候滚动更新
              </span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
              {FOOTER_LINKS.map((col) => (
                <nav key={col.group} aria-label={col.group}>
                  <h3 className="mb-4 text-sm font-bold text-background-50">{col.group}</h3>
                  <ul className="space-y-3">
                    {col.items.map((name) => (
                      <li key={name}>
                        <button
                          type="button"
                          onClick={() => handleClick(col.group, name)}
                          className="cursor-pointer text-sm text-background-300 transition-colors hover:text-accent-300"
                        >
                          {name}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <span>© {year} 51黑瓜速递</span>
            <span className="hidden sm:inline">·</span>
            <span>51黑瓜最新动态 / 51黑瓜快讯 / 51黑瓜即时热点速递</span>
          </p>
          <p className="flex items-center gap-2">
            <i className="ri-information-line"></i>
            热点信息仅供参考,请理性看待网络内容
          </p>
        </div>
      </div>
    </footer>
  );
}